(function () {
  class NumbersAnimation {
    constructor(root) {
      this.root = root;
      this.headings = [];
      this.observer = null;

      // A link inside the heading would lose its accessible name once split
      const headings = Array.from(
        root.querySelectorAll(".numbers-card .block-heading")
      ).filter((el) => el.textContent.trim() && !el.querySelector("a"));

      if (!headings.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio < 1) return;
            entry.target.classList.add("numbers-animate--visible");
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 1 }
      );

      headings.forEach((el) => {
        this._splitCharacters(el);
        this.headings.push(el);
        this.observer.observe(el);
      });
    }

    destroy() {
      if (this.observer) this.observer.disconnect();

      this.headings.forEach((el) => {
        if (el._originalHtml === undefined) return;
        el.innerHTML = el._originalHtml;
        el.removeAttribute("aria-label");
        el.classList.remove("numbers-animate--visible");
        delete el._originalHtml;
      });
      this.headings = [];
    }

    // Every character animates, symbols included. Words are wrapped too, so a
    // value like "50K" can never break across two lines mid-word.
    _splitCharacters(el) {
      el._originalHtml = el.innerHTML;
      el.setAttribute("aria-label", el.textContent.trim());

      let charIndex = 0;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        if (!node.nodeValue.trim()) return;

        const fragment = document.createDocumentFragment();

        node.nodeValue.split(/(\s+)/).forEach((chunk) => {
          if (!chunk) return;

          if (!chunk.trim()) {
            fragment.appendChild(document.createTextNode(chunk));
            return;
          }

          const word = document.createElement("span");
          word.className = "numbers-word";
          word.setAttribute("aria-hidden", "true");

          Array.from(chunk).forEach((char) => {
            const character = document.createElement("span");
            character.className = "numbers-char";
            character.style.setProperty("--char-index", charIndex);

            const inner = document.createElement("span");
            inner.className = "numbers-char__inner";
            inner.textContent = char;
            charIndex += 1;

            character.appendChild(inner);
            word.appendChild(character);
          });

          fragment.appendChild(word);
        });

        node.parentNode.replaceChild(fragment, node);
      });
    }
  }

  function initSection(section) {
    if (!section || !section?.classList.contains("numbers-section")) {
      return;
    }

    const root = section.querySelector(".numbers");
    if (!root || root.dataset.headingAnimation !== "true") return;

    if (root._numbersAnimationInstance) {
      root._numbersAnimationInstance.destroy();
      root._numbersAnimationInstance = null;
    }
    root._numbersAnimationInstance = new NumbersAnimation(root);
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeNumbersEvents) {
    window.__themeNumbersEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll(".numbers").forEach((el) => {
        if (!el._numbersAnimationInstance) return;

        el._numbersAnimationInstance.destroy();
        el._numbersAnimationInstance = null;
      });
    });
  }
})();
